import { render, staticRenderFns } from "./ContractTypeSelect.vue?vue&type=template&id=87c40be6&lang=pug"
import script from "./ContractTypeSelect.vue?vue&type=script&lang=js"
export * from "./ContractTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports